import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  closeSharePop,
  closeReplyPop,
  reportPost,
  reportReply,
  openConfirmDialog,
} from '@app-core/app/actions'
import SharePop from './SharePop'
import ReplyPop from './ReplyPop'
import Immutable from 'immutable'

class SharePopContainer extends PureComponent {
  static defaultProps = {
    isSharePopOpen: false,
    isReplyPopOpen: false,
    url: '',
    userId: '',
    replyID: -1,
    isCurrentUserComment: false,
    post: Immutable.fromJS({}),
    deletePost: Immutable.fromJS({}),
  }

  _reportPost = () => {
    const { post, reportPost } = this.props
    reportPost({ post: post.toJS() })
  }

  _reportReply = ({ postID, replyID }) => {
    const { reportReply } = this.props
    reportReply({ postID, replyID })
  }

  render() {
    const { isSharePopOpen, post, url, userId, closeSharePop } = this.props
    const { isReplyPopOpen, deletePost, replyID, isCurrentUserComment, closeReplyPop } = this.props
    const { openConfirmDialog } = this.props
    const renderPop = []
    if (isSharePopOpen) {
      renderPop.push(
        <SharePop
          key="SharePop"
          sharePost={post}
          isOpen={isSharePopOpen}
          url={url}
          userId={userId}
          onClose={closeSharePop}
          openConfirmDialog={openConfirmDialog}
          onClickReport={this._reportPost}
        />,
      )
    }
    if (isReplyPopOpen) {
      renderPop.push(
        <ReplyPop
          key="ReplyPop"
          replyPost={deletePost}
          isOpen={isReplyPopOpen}
          replyID={replyID}
          isCurrentUserComment={isCurrentUserComment}
          onClose={closeReplyPop}
          openConfirmDialog={openConfirmDialog}
          onClickReport={this._reportReply}
        />,
      )
    }
    return renderPop
  }
}

const mapStateToProps = (state) => ({
  userId: state.currentUser.getIn(['userInfo', 'uid']),
  isSharePopOpen: state.app.getIn(['sharePop', 'isOpen']),
  url: state.app.getIn(['sharePop', 'url']),
  post: state.app.getIn(['sharePop', 'post']),
  isReplyPopOpen: state.app.getIn(['replyPop', 'isOpen']),
  deletePost: state.app.getIn(['replyPop', 'post']),
  replyID: state.app.getIn(['replyPop', 'replyID'], -1),
  isCurrentUserComment: state.app.getIn(['replyPop', 'isCurrentUserComment']),
})

export default connect(mapStateToProps, {
  closeSharePop,
  closeReplyPop,
  reportPost,
  reportReply,
  openConfirmDialog,
})(SharePopContainer)
